import React, { FC } from 'react';

import { Grid, List, ListItem, Typography } from '@material-ui/core';
import BrokenImageIcon from '@material-ui/icons/BrokenImage';
import theme from '../../theme';
import { Team } from '../../utils/types';
import { Img } from './ImageWithFallback';

export const TeamList: FC<TeamListProps> = (props) => {
	const { teams } = props;

	return (
		<Grid container item>
			<Grid item xs={3}>
				<Typography variant='subtitle2'>Teams</Typography>
			</Grid>
			<Grid item xs={9}>
				<List style={{ padding: 0 }}>
					{teams?.length &&
						teams.map((team, idx) => (
							<ListItem key={`team-${idx}`} style={{ paddingLeft: 0, paddingTop: 0 }}>
								{team.logoUrl && (
									<Img
										src={team.logoUrl || ''}
										alt={team.name || ''}
										fallback={<BrokenImageIcon style={{ fontSize: 40, color: theme.palette.error.main }} />}
										width='40px'
									/>
								)}
								<Typography variant='body2' style={{ marginLeft: theme.spacing(1) }}>
									{team.name}
									{team.abbreviation && (
										<span>
											&nbsp;(<strong>{team.abbreviation}</strong>)
										</span>
									)}
								</Typography>
							</ListItem>
						))}
				</List>
			</Grid>
		</Grid>
	);
};

type TeamListProps = { teams?: Team[] };

export default TeamList;
